module.exports = __webpack_public_path__ + "static/img/01.c59e00c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/01.jpg
// module id = Xxyt
// module chunks = 0